//Components
import PollCreation from "../Components/PollCreation";

const CreatePoll = () => {
  return (
      <PollCreation />
  );
};

export default CreatePoll;